import { keyframes, css } from 'styled-components';
import { ANIMATION_TIME_SECONDS } from './constants.js';

const slideInRight = keyframes `
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
`;
const slideOutRight = keyframes `
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
`;
const animateSlideInRight = css `
  transition: transform 0.6s ease-in-out;
  animation: ${slideInRight} ${ANIMATION_TIME_SECONDS}s;
`;
const animateSlideOutRight = css `
  transition: transform 0.6s ease-in-out;
  animation: ${slideOutRight} ${ANIMATION_TIME_SECONDS}s;
`;

export { animateSlideInRight, animateSlideOutRight, slideInRight, slideOutRight };
